import { useQuery } from "@tanstack/react-query"
import { getPortOfVirginiaShips } from "../services/query_service"

export const usePovShipsQuery = (containers: string[]) => {
    return useQuery({
        queryKey: ['ships', 'pov'],
        queryFn: () => getPortOfVirginiaShips(containers)
    })
}